/*
 * Public API Surface of ngx-colors
 */
export * from "./lib/directives/ngx-colors-trigger.directive";
export * from "./lib/ngx-colors.component";
export * from "./lib/ngx-colors.module";
export * from "./lib/clases/color";
export * from "./lib/validators/valid-color.validator";
